export const POLICYSTREAM_FORMS = {
  basicInfo: 'basic_info',
  needsAnalysis: 'needs_analysis',
  applicationForm: 'application_general',
  basicClientInfo: 'basic_client_info',
} as const;

export const POLICYSTREAM_API_NAMES = {
  basicInfo: {
    dateOfBirth: 'date_of_birth',
    sex: 'gender_sex_at_birth',
    nicotineUse: 'nicotine_use',
    province: 'province',
  },
  needsAnalysis: {
    personalDebt: 'outstanding_personal_debt',
    annualIncome: 'annual_income',
    yearsOfIncomeReplacement: 'years_of_income_replacement',
    mortgageBalance: 'mortgage',
    numberOfChildren: 'number_of_children',
    payingForChildrensEducation: 'education_boolean',
    existingLifeInsuranceAmount: 'total_existing_life_insurance_amount',
    existingSavingsInvestmentsAmount: 'total_savings_investments_amount',
  },
  applicationGeneral: {
    personalInformation: 'personal_information',
    sex: 'gender_sex_at_birth',
    phoneNumber: 'phone_number',
    purposeOfInsurance: 'purpose_of_insurance',
    personalInsuranceSubtype: 'personal_insurance_subtype',
    firstName: 'first_name',
    lastName: 'last_name',
    beneficiaryInformation: 'beneficiary_information', // container
    primaryBeneficiaries: 'primary_beneficiaries',
    contingentBeneficiariesConditional: 'contingent_beneficiaries_conditional',
    contingentBeneficiaries: 'contingent_beneficiaries',
    beneficiaryShare: 'share',
    bankingInformation: 'banking_information',
    bankNameConditional: 'name_of_bank_conditional',
    bankName: 'name_of_bank',
    transitNumber: 'transit_number',
    institutionNumber: 'institution_number',
  },
  basicClientInfo: {
    firstName: 'first_name',
    lastName: 'last_name',
    email: 'contact_email',
    phoneNumber: 'phone_number',
  },
} as const;

export const MIN_AGE = 18;
export const MAX_AGE = 65;

export const TRANSIT_NUMBERS = {
  bmo: '001',
  scotiaBank: '002',
  rbc: '003',
  td: '004',
  cibc: '010',
} as const;

export const POLICYSTREAM_SUPPORT_EMAIL = 'support@policystream.ca';

export const POLICY_TERM_YEARS = [10, 15, 20, 25, 30] as const;
export type PolicyTermLength = typeof POLICY_TERM_YEARS[number];
